import { destroy as destroyReq, get, patch, post, transformRequestData } from "./utils/requests"

import LongTermReservationsProps from '../interfaces/ILongTermReservation'
import IInvoice from "../interfaces/IInvoice"
import { ReservationProps } from "~/interfaces"

const fetch = (id: string): Promise<{ long_term_reservation: LongTermReservationsProps }> =>
  get(`/api/long_term_reservations/${id}`)

const update = (id: string, data: {is_enabled_auto_charging: boolean}): Promise<{ long_term_reservation: LongTermReservationsProps }> =>
  patch(`/api/long_term_reservations/${id}`, data)

const nextChargedInvoice = (id: string): Promise<{ invoices: IInvoice[] }> =>
  get(`/api/long_term_reservations/${id}/invoices`, transformRequestData({ onlyNextCharged: true }))

const createFinalInvoice = (campId: string, id: string): Promise<{ reservation: ReservationProps }> =>
  post(`/api/camps/${campId}/long_term_reservations/${id}/reservations`)

const destroy = (id: string): Promise<void> =>
  destroyReq(`/api/long_term_reservations/${id}`)

const LongTermReservations = {
  createFinalInvoice,
  destroy,
  fetch,
  nextChargedInvoice,
  update,
}

export default LongTermReservations
